import { Alert } from "@mui/material";
import { Checkbox, FormGroup } from "@mui/material";
import { Box, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import React, { useState } from "react";
import useBSSLogger from "../../../../hooks/useBSSLogger";
import __t from "../../../../lib/traduzioni";
import { BSSConfirmDialog} from "../../../form/BSSDialog";
const {logger} = useBSSLogger();


const DialogCampiRicerca = ({campiRicerca, filtri, setFiltri, dialogCampiRicerca, setDialogCampiRicerca}) => {

    const defFiltroCampi = Object.entries(campiRicerca).reduce((obj, [k, v]) => ({...obj, [k]: false}), {});

    const [filtroCampi, setFiltroCampi] = useState(defFiltroCampi);

    const aggiornaFiltriCampi = (value, checked) => {

        setFiltroCampi({...filtroCampi, [value]: checked})
    }

    const filtraCampi = (filtroCampi) => {

        const nuoviFiltri = {
            campiRicerca: Object
                .entries(filtroCampi)
                .filter(([campo, checked]) => checked)
                .reduce((arr, [campo]) => [
                    ...arr,
                    campo
                ], [])
        }

        setFiltri({
            ...filtri, 
            filtriRicerca: {
                ...filtri.filtriRicerca,
                ...nuoviFiltri
            }, 
            skip: 0
        });
        setFiltroCampi(defFiltroCampi)
        setDialogCampiRicerca({mostra: false})
    }

    return (
        <BSSConfirmDialog
            title={__t("includiinricercatestuale")}                                                        
            open={dialogCampiRicerca.mostra} 
            undoAction={e => setDialogCampiRicerca({mostra: false})} 
            confirmAction={e => {
                filtraCampi(filtroCampi)
            }}
            sx={{"& .MuiDialogContent-root": {p: 0}}}
        >
            <Box p={2}>
                {/* <pre>{JSON.stringify(filtroCampi, null, 2)}</pre> */}
                <FormGroup                   
                >
                    <Alert severity="info">
                        {__t("campiricercavuotoinfo")}
                    </Alert>
                    {Object.entries(campiRicerca).map(([k, v]) => {
                        return (
                            <FormControlLabel 
                                sx={{
                                    "& .MuiFormControlLabel-label": {
                                        textDecoration: (Object.values(filtroCampi).find(v => v === true) && !filtroCampi[k]) ? 'line-through' : 'none'
                                    }
                                }}
                                onChange={e => {
                                    aggiornaFiltriCampi(e.target.value, e.target.checked)
                                }}
                                key={k} 
                                value={k} 
                                checked={filtroCampi[k]}
                                control={<Checkbox />} 
                                label={v} 
                            />
                        )
                    })}
                </FormGroup>
                
            </Box>

        </BSSConfirmDialog>
    )
}

export default DialogCampiRicerca;